import { render, staticRenderFns } from "./LessonDetailMobile.vue?vue&type=template&id=789a0123&scoped=true"
import script from "./LessonDetailMobile.vue?vue&type=script&lang=js"
export * from "./LessonDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./LessonDetailMobile.vue?vue&type=style&index=0&id=789a0123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a0123",
  null
  
)

export default component.exports